import { Text } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background-size: contain;
  background-position: center center;
  position: fixed;
  right: 0;
  left: 200px;
  top: 60px;
  bottom: 0;
  pointer-events: none;
  background-repeat: no-repeat;
  /* filter: brightness(0.9) contrast(1.1); */

  @media (max-width: 768px) {
    left: 0;
    background-image: none !important;
  }
`;

export const Details = styled.div`
  position: absolute;
  top: 60px;
  left: 60px;
  animation-delay: 0.5s;

  @media (max-width: 768px) {
    position: relative;
    left: 30px;
    top: 0;
  }
`;

export const Header = styled(Text)`
  font-size: 40px;
  margin-top: -10px;

  @media (max-width: 768px) {
    font-size: 30px;
  }
`;

export const Actions = styled.div`
  position: absolute;
  bottom: 80px;
  right: 180px;
  animation-delay: 1s;
  pointer-events: all;

  @media (max-width: 768px) {
    right: auto;
    position: relative;
    bottom: 0;
    left: 140px;
  }
`;

export const ImageMobile = styled.div`
  width: 100vw;
  height: 500px;
  background-size: 150%;
  background-position: center center;
  margin: 0;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;
